import type { SeoMetadata } from '@/types/datocms-schema'

import { JsonLdScript } from '@/components/shared/JsonLdScript'

type ProductSchemaProps = {
  metadata?: SeoMetadata
  /** Used when the CMS SEO title is empty, so the entity always has a name. */
  fallbackName: string
}

// Product entity only — deliberately no Offer/price fields: published prices
// persist in search caches long after they change.
export const ProductSchema = ({ metadata, fallbackName }: ProductSchemaProps) => {
  const imageSrc = metadata?.image?.responsiveImage?.src
  // JSON.stringify drops undefined keys, so empty CMS fields never reach the schema.
  return (
    <JsonLdScript
      id="product-jsonld"
      data={{
        '@type': 'Product',
        name: metadata?.title || fallbackName,
        brand: { '@type': 'Brand', name: 'ZOE' },
        description: metadata?.description || undefined,
        image: imageSrc ? [imageSrc] : undefined,
      }}
    />
  )
}
